import React from 'react'
import LocationRouter from '../StoreLayouts/LocationRouter'



class TapsCans extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            tapMenu: '',
            canMenu: ''
        }
    }
    refactorAbv = (abv) => {
        let number = parseFloat(abv)
        return number
    }
    refactorPrice = (price) => {
        console.log(price)
        let number = parseInt(price.name)
        return number
    }
    componentDidMount(){
        const tapsId = this.props.match.params.tapsId;
        const cansId = this.props.match.params.cansId;
        const location = this.props.match.params.location;

        this.getTapsAndCans(tapsId, cansId, location)
    }
    getBeerMenu = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            return data
        })
        .catch(err => err)
    }
    getTapsAndCans = (tapMenuId, canMenuId, location) => {
        Promise.all([this.getBeerMenu(tapMenuId), this.getBeerMenu(canMenuId)])
        .then(([tapMenu, canMenu]) => this.setState({tapMenu: tapMenu.menu, canMenu: canMenu.menu, location: location}))
        .catch(err => err)
    }
    filterStyle = (style) => {
        
        if (style === "IPA - American"){
            return "IPA"
        } else if (style === "Stout - Milk / Sweet"){
            return "Stout"
        } else if (style === "Sour - Fruited Berliner Weisse"){
            return "Sour"
        }  else if (style === "IPA - New England / Hazy"){
            return "Hazy IPA"
        }  else if (style === "Pale Ale - New England / Hazy"){
            return "Hazy Pale"
        } else if (style === "Pale Ale - English" || style === "Pale Ale - American"){
            return "Pale Ale"
        } else if (style.includes('Pilsner')){
            return "Pilsner"
        } else if (style.includes("Cider - Traditional")){
            return "Cider"
        } else if (style.includes("Stout - American")){
            return "Stout"
        } else if (style.includes("Stout - Russian Imperial")){
            return "Imperial Stout"
        } else if (style.includes("Brown Ale")){
            return "Brown Ale"
        } else if (style.includes("Wheat Beer - Witbier / Blanche")){
            return "Witbier"
        } else if (style.includes("Non-Alcoholic Beer")){
            return "NA Beer"
        }
        
            else {
            return style
        }
    }
    filterBrewery = (brewery) => {
        console.log(brewery)
        if (brewery.includes("Brewery")){
            return brewery.replace("Brewery", "")
        } else if (brewery.includes("Brewing") || brewery.includes('Company') || brewery.includes('Co.') || brewery.includes("Cooperative")){
            return brewery.replace('Brewing', "").replace('Company', "").replace('Co.', "").replace("Cooperative", "COOP").replace('Co ', "")
        } else if (brewery.includes('Brew Labs')){
            return brewery.replace('Brew Labs', "")
        }  else if (brewery.includes('Werks')){
            return brewery.replace("Werks", "")
        } else if (brewery.includes("Beer")){
            return (brewery.replace("Beer", ""))
        } else if (brewery.includes("Anheuser-Busch")){
            return "AB InBev"
        } 
            else {
            return brewery
        }
        
    }
    filterItem = (item) => {
        if (item.includes("Pilsner Style Beer")){
            return "Pilsner"
        } else if (item.includes("Bent Paddle Cold Press Nitro")){
            return "Cold Press Nitro"
        } else if (item.includes("Jameson Barrel Aged Brown Ale")){
            return "Jameson Barrel Aged"
        } else if (item.includes("Gravity Well")){
            return "Gravity Well"
        } else if (item.includes("Castle Cream Ale")){
            return "Cream Ale"
        } else if (item.includes("Lollygagger Pale Ale")){
            return "Lollygagger"
        } else if (item.includes("Pyro American Pale Ale")){
            return "Pyro American"
        } else if (item.includes("Bent Hop | India Pale Ale")){
            return "Bent Hop"
        } else if (item.includes("Cold Press Black | Coffee Ale")){
            return "Cold Press Black"
        } else if (item.includes("Venture Pils | Pilsener Lager")){
            return ("Venture Pils")
        }
        
        else {
            return item
        }
    }
    
    render(){
        console.log(this.state)
        console.log(this.props)
        return(
            <>
                <LocationRouter 
                    location={this.state.location}
                    tapMenu={this.state.tapMenu}
                    canMenu={this.state.canMenu}
                    filterStyle={this.filterStyle}
                    filterBrewery={this.filterBrewery}
                    filterItem={this.filterItem}
                    refactorAbv={this.refactorAbv}
                />
            </>
        )
    }
}
export default TapsCans